var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnePageSecondStyleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008244"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_5080)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 8,
    fill: "#FFFCF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1115",
    cx: 10.5,
    cy: 49.5,
    rx: 33,
    ry: 32.5,
    fill: "#ADFF44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Topographic 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.8118 40.6282C66.0517 45.6535 67.397 56.3005 71.418 60.192C75.8595 64.4889 89.1724 57.3249 90.1889 55.2999C91.2054 53.2749 76.6336 55.0921 76.3044 49.3893C75.9402 43.0589 85.6855 38.5135 84.4355 36.3199C83.2059 34.1613 74.1584 34.8198 69.8118 40.6282Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.0247 40.6569C63.2674 45.7256 65.605 58.2846 70.429 62.4684C75.8947 67.2062 89.7753 58.0458 91.5691 56.0584C93.1159 54.3465 78.4213 54.5076 77.3845 47.9134C76.2564 40.7497 84.607 35.6139 83.3173 34.4303C81.9328 33.1624 73.6099 34.7157 68.0247 40.6569Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.2334 40.6951C60.4866 45.7943 63.8129 60.2685 69.4336 64.7456C75.9304 69.9262 90.2398 58.806 92.9373 56.8225C94.896 55.3756 80.2145 53.9302 78.4537 46.4415C76.5766 38.4541 83.6809 32.5482 82.1937 32.5609C80.8367 31.9887 73.0819 34.6157 66.2334 40.6951Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.4323 40.7347C57.707 45.8773 62.0155 62.2522 68.4344 67.0258C75.9622 72.6315 91.3649 60.5514 94.3018 57.588C96.1412 55.7312 82.0099 53.3529 79.521 44.977C76.9025 36.1621 82.6704 29.5748 81.0659 30.6909C79.6407 30.9138 72.5491 34.5325 64.4323 40.7347Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.6189 40.7699C54.9182 45.9599 60.207 64.2313 67.4146 69.311C75.9793 75.3483 91.6602 61.4813 95.6516 58.3551C97.8907 56.5993 83.7932 52.7773 80.5706 43.5095C77.2087 33.8659 81.9667 26.894 79.9193 28.8156C78.6073 30.0453 72.0082 34.4407 62.6189 40.7699Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.7984 40.7944C52.1245 46.0397 58.3922 66.1997 66.3898 71.5808C75.9948 78.0456 91.2963 60.7966 96.9993 59.1157C99.9534 58.2418 85.5798 52.1917 81.6169 42.0339C77.5328 31.5561 80.9509 23.8094 78.7704 26.9364C77.4103 28.8751 71.4634 34.3475 60.7984 40.7944Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M58.9782 40.8236C49.3308 46.1243 56.5766 68.1668 65.3667 73.8606C76.0159 80.7495 91.6345 61.3622 98.3475 59.8698C101.632 59.1401 87.3674 51.6006 82.6618 40.5517C77.8428 29.2362 79.8939 20.7528 77.6191 25.0444C76.1927 27.7368 70.9236 34.2588 58.9782 40.8236Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.1568 40.8513C46.5378 46.2117 54.7689 70.1404 64.3446 76.1393C76.0335 83.4544 91.9791 61.8971 99.6996 60.6302C103.32 60.0353 89.1601 51.0082 83.7119 39.0735C78.1652 26.9242 78.8337 17.7254 76.4715 23.159C74.9678 26.6139 70.382 34.1762 57.1568 40.8513Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.3358 40.8795C43.7458 46.3009 52.9521 72.1134 63.3229 78.4181C76.0545 86.1579 92.3337 62.4167 101.052 61.3922C105.015 60.9272 90.9567 50.4197 84.7616 37.5977C78.4873 24.6109 77.776 14.7132 75.3239 21.2741C73.7405 25.5034 69.8461 34.0936 55.3358 40.8795Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.5152 40.9096C40.9491 46.4014 51.1392 74.0828 62.3004 80.6954C76.0709 88.8599 92.693 62.9141 102.403 62.1498C106.714 61.8103 92.7513 49.8266 85.8098 36.119C78.8094 22.2942 76.7221 11.7027 74.1729 19.3873C72.513 24.3985 69.3081 34.0158 53.5152 40.9096Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.6939 40.9381C38.1602 46.4857 49.3231 76.0533 61.2784 82.9739C76.0969 91.5585 93.0665 63.4026 103.754 62.9102C108.417 62.6925 94.5494 49.2334 86.86 34.6408C79.1328 19.9767 75.6647 8.70257 73.0243 17.5027C71.2849 23.2973 68.769 33.9404 51.6939 40.9381Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M49.8729 40.9682C35.3681 46.5802 47.5166 78.0208 60.2566 85.2536C76.1194 94.2583 93.4319 63.8907 105.103 63.6673C110.121 63.5738 96.3467 48.6436 87.907 33.1603C79.4552 17.6576 74.6097 5.70105 71.8738 15.6153C70.059 22.1986 68.2302 33.8666 49.8729 40.9682Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M48.0522 41.0002C32.5749 46.6773 45.7077 79.9966 59.2338 87.5319C76.1414 96.9581 93.808 64.3718 106.455 64.4315C111.832 64.457 98.1445 48.0483 88.9579 31.687C79.7713 15.3258 73.5578 2.70924 70.7239 13.7316C68.8315 21.1028 67.6921 33.7963 48.0522 41.0002Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M46.2307 41.0306C29.7818 46.7742 43.8931 81.9585 58.2099 89.8117C76.1655 99.6631 94.1917 64.8541 107.803 65.1937C113.541 65.3383 99.9409 47.4548 90.0056 30.2113C80.1037 13.0289 72.5071 -0.283322 69.574 11.8531C67.6043 20.0084 67.1531 33.7245 46.2307 41.0306Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.4082 41.062C26.9877 46.8721 42.0975 83.8992 57.1909 92.0894C76.2089 102.318 94.5765 65.318 109.155 65.9523C115.255 66.2175 101.742 46.8594 91.0564 28.7344C80.4311 10.7118 71.4588 -3.27818 68.4269 9.96843C66.3756 18.9152 66.611 33.6581 44.4082 41.062Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M42.5873 41.0943C24.1954 46.9708 40.2845 85.8691 56.1625 94.3675C76.2242 105.025 94.9516 65.7824 110.497 66.713C116.962 67.0959 103.533 46.2647 92.0963 27.2553C80.7485 8.39023 70.401 -6.27213 67.2689 8.08167C65.1479 17.8215 66.0707 33.5891 42.5873 41.0943Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M40.7653 41.1264C21.3952 47.0744 38.4701 87.842 55.1398 96.6486C76.2373 107.717 95.3405 66.2622 111.844 67.477C118.681 67.9777 105.365 45.6533 93.1438 25.786C81.1078 6.05932 69.3511 -9.25586 66.1203 6.20794C63.92 16.731 65.5286 33.5236 40.7653 41.1264Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M38.9433 41.1589C18.6166 47.2074 36.6557 89.8151 54.1164 98.9285C76.2586 110.428 95.7287 66.7319 113.192 68.2391C120.388 68.8604 107.153 45.0646 94.191 24.3118C81.4241 3.74874 68.3 -12.2422 64.967 4.32779C62.6919 15.6408 64.998 33.5031 38.9433 41.1589Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M37.121 41.1934C15.8202 47.3008 34.8429 91.7856 53.092 101.209C76.2733 113.131 96.1164 67.1997 114.537 69.0023C122.1 69.7421 108.939 44.4726 95.2353 22.839C81.7391 1.43899 67.2487 -15.2299 63.8148 2.44924C61.4614 14.5609 64.4525 33.429 37.121 41.1934Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M35.2984 41.2269C13.0243 47.3946 33.0264 93.7599 52.0672 103.487C76.2877 115.829 96.5077 67.668 115.881 69.7644C123.813 70.6234 110.736 43.885 96.2813 21.3713C82.0484 -0.862011 66.1668 -18.215 62.6639 0.574372C60.211 13.4606 63.9065 33.3538 35.2984 41.2269Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.4764 41.2597C10.2271 47.4832 31.208 95.7362 51.0435 105.767C76.3063 118.535 96.8993 68.1355 117.223 70.5212C125.525 71.4987 112.514 43.2935 97.3228 19.8874C82.3689 -3.18115 65.1309 -21.2022 61.5096 -1.31001C58.9949 12.3743 63.3672 33.2841 33.4764 41.2597Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M60.3551 -3.1864C57.7768 11.2878 62.8131 33.2056 31.6538 41.2952C7.43118 47.5826 29.3958 97.7048 50.017 108.047C76.3222 121.239 97.2894 68.6041 118.568 71.2894C135.777 73.463 67.8936 -45.5162 60.3551 -3.1864Z",
    stroke: "#4A3AFF",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1117",
    cx: 44,
    cy: 14.5,
    r: 6.5,
    fill: "#670DC0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7337",
    x: -15.5,
    y: 27,
    width: 36,
    height: 12,
    rx: 6,
    fill: "#670DC1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 71,
    height: 71,
    rx: 7.5,
    stroke: "#DBDADE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_5080"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePageSecondStyleIcon);
export default __webpack_public_path__ + "static/media/OnePageSecondStyleIcon.bf60561519dd1534d8919f5332fff5d7.svg";
export { ForwardRef as ReactComponent };